import { Modal } from "antd";
import { useRef } from "react";
import FooterModal from "ui/components/Button/FooterModal";
import ExportCertidaoNegativaDebitos from "./ExportCertidaoNegativaDebitos";

interface ModalExportCertidaoNegativaDebitosProps {
  visible: boolean;
  onClose: () => any;
  defaultUnidadeId?: string;
}

function ModalExportCertidaoNegativaDebitos({
  visible,
  onClose,
  defaultUnidadeId,
}: ModalExportCertidaoNegativaDebitosProps) {
  const exportRef = useRef<{
    submitForm: (callback?: () => any) => any;
  } | null>(null);

  const onSubmit = () => {
    exportRef.current?.submitForm(onClose);
  };

  return (
    <Modal
      destroyOnClose
      width="700px"
      footer={
        <FooterModal
          registerAnother={false}
          setRegisterAnother={() => null}
          onSubmit={onSubmit}
          onClose={onClose}
          showRegisterAnother={false}
          primaryButtonText="Gerar certidão"
          buttonCancelarText="Fechar"
        />
      }
      centered
      bodyStyle={{
        borderRadius: 16,
      }}
      title={"Gerar certidão negativa de débitos"}
      visible={visible}
      onCancel={onClose}
      closable={true}
    >
      <ExportCertidaoNegativaDebitos
        defaultUnidadeId={defaultUnidadeId}
        ref={exportRef}
        showSubmitButton={false}
      />
    </Modal>
  );
}

export default ModalExportCertidaoNegativaDebitos;
